import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { QuestionImage } from '../shared';

// FillInTheBlankコンポーネント
const FillInTheBlank = ({ question, answered, isTimeUp, handleSubmit, quickAnswerMode = 'standard' }) => {
  const [userAnswer, setUserAnswer] = useState('');

  // フォームの無効化状態を判定
  const isDisabled = answered || isTimeUp;

  const handleAnswerSubmit = () => {
    if (isDisabled) return;

    const trimmedAnswer = userAnswer.trim();
    const correctAnswer = question.answer.trim();
    const isCorrect = trimmedAnswer.toLowerCase() === correctAnswer.toLowerCase();

    // 回答データの構造を整理
    handleSubmit(
      isCorrect,
      question.explanation || "解答が送信されました。",
      correctAnswer,
      trimmedAnswer,
      {
        type: 'fill-in-the-blank',
        question: question.question,
        answer: question.answer,
        explanation: question.explanation,
        userAnswer: trimmedAnswer
      }
    );

    setUserAnswer('');
  };

  return (
    <div className={isDisabled ? 'opacity-70' : ''}>
      {/* 画像表示（存在する場合） */}
      {question.questionImage && (
        <div className="mb-4">
          <QuestionImage imageData={question.questionImage} />
        </div>
      )}
      
      {/* 問題文（画像がない場合は必須、ある場合は補足として表示） */}
      {question.question && (
        <h3 className="text-xl font-semibold text-purple-900 mb-4">{question.question}</h3>
      )}
      
      <input
        type="text"
        placeholder="答えを入力してください"
        value={userAnswer}
        onChange={(e) => setUserAnswer(e.target.value)}
        className={`w-full p-2 border rounded mb-4 ${isDisabled ? 'cursor-not-allowed' : ''}`}
        disabled={isDisabled}
        aria-label="穴埋め問題の回答入力"
      />
      <div className="flex justify-end">
        <button
          onClick={() => !isDisabled && handleAnswerSubmit()}
          className={`px-4 py-2 rounded 
            ${isDisabled ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-purple-600 text-white hover:bg-purple-700'}`}
          disabled={isDisabled || userAnswer.trim() === ''}
          aria-label="回答を送信するボタン"
        >
          回答する
        </button>
      </div>
    </div>
  );
};

FillInTheBlank.propTypes = {
  question: PropTypes.object.isRequired,
  answered: PropTypes.bool.isRequired,
  isTimeUp: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  quickAnswerMode: PropTypes.string,  // クイック回答モード設定
};

export default FillInTheBlank; 